import { Checkbox, CircularProgress, FormControlLabel, FormHelperText, Grid, InputLabel, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { formatters, SelectBox, SimpleField } from '../../../../../../Core/Controls';
import { Alert } from '@material-ui/lab';
import { GreenCheckbox } from '../../../../../../Core/Controls/Inputs/Checkbox';
import SellerInvoiceModal from '../../JOBItems/JobInvoiceLines/sellerInvoice';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { useHistory } from 'react-router-dom';

const JobAdminstration = ({ handleNext, jobDetails, isDisabled, jobStatus, customersList, isProformaCreated, redirectToSalesInv }) => {
    const history = useHistory();
    const [state, setState] = useState({
        showMailBody: false,
        performaButtons: 2,
        performaLabel: 'Download',
        salesInvoiceStatus: jobStatus === 'AS' ? 'P' : null,
        jobApprovedOrderNo: '',
        jobasInvoiced: false,
        jobasproforma: jobStatus === 'AS' ? true : false,
        isDocuments: false,
        isShowPerformaInvoice: false,
        isButtonShow: false,
        jobCustomerID: jobDetails.customerID,
        emailEventDoc: false,
        openLines: '',
        showLoader: true,
        isProforma: false,
        isShowInvoice: false,
        isMismatch: '',
        jobCustomerOrderNo: jobDetails.jobCustomerOrderNo || ''
    });

    const [errors, setErrors] = useState({});

    const stopLoader = () => {
        setState((st) => ({ ...st, showLoader: false }));
    };

    const handleCheck = (e) => {
        const { name, checked } = e.target;
        setState((st) => {
            let NewSt = { ...st };
            if (name === 'jobasInvoiced') {
                NewSt.salesInvoiceStatus = 'I';
                NewSt.showMailBody = false;
            } else if (name === 'jobasproforma') {
                NewSt.salesInvoiceStatus = 'P';
                NewSt.showMailBody = false;
                NewSt.isProforma = false;

                // NewSt.isProforma = checked;
            }
            if (!checked) {
                if (name === 'jobasInvoiced') {
                    NewSt.salesInvoiceStatus = 'P';
                } else if (name === 'jobasproforma') {
                    NewSt.salesInvoiceStatus = null;
                }

                // if (NewSt.isProforma) {
                //     NewSt.salesInvoiceStatus = 'P';
                // } else {
                //     NewSt.salesInvoiceStatus = null;
                // }
            }
            NewSt[name] = checked;

            return NewSt;
        });
    };

    const showPerformaInvoice = (bool) => {
        setState((st) => ({ ...st, isShowPerformaInvoice: bool }));
    };
    const showOpenLine = (params) => {
        if (params)
            setState((st) => ({
                ...st,
                openLines: params.openLines,
                isProforma: params.isProforma,
                isShowInvoice: params.isProforma,
                mismatchedLines: params.mismatchedLines,
                jobasproforma: params.isProforma,
                isMismatch: params.mismatchedLines
            }));
    };

    const inputChange = (e) => {
        const { name, value, type, checked } = e.target;
        console.log('value');

        if (type == 'checkbox') {
            setState((st) => ({ ...st, [name]: checked }));
        } else {
            setState((st) => ({ ...st, [name]: value }));
        }
    };

    const handleSubmitValue = () => {
        handleNext();
        redirectToSalesInv();
    };

    // const setAPIScheduleDocEmail = (obj, isDocuments) => {
    //     setState((st) => ({ ...st, sentBy: obj.sentBy, sendEmailTo: obj.email, isDocuments: isDocuments }));
    // };

    return (
        <div style={{ padding: '0px 10px' }}>
            <Grid container spacing={1} alignContent="flex-start">
                {state.showLoader ? (
                    <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', height: 500, alignItems: 'center' }}>
                        <CircularProgress />
                    </Grid>
                ) : (
                    <>
                        <Grid item container xs={12} spacing={1} justifyContent="space-between">
                            <Grid item xs sm md lg={2}>
                                <FormHelperText shrink>Order Date</FormHelperText>
                                <Typography variant="button">{jobDetails?.jobOrderDate || 'N/A'}</Typography>
                            </Grid>
                            <Grid item xs sm md lg={2}>
                                <FormHelperText shrink>Job Reference</FormHelperText>
                                <Typography variant="button">{jobDetails?.jobAgentOrderNo || 'N/A'}</Typography>
                            </Grid>

                            <Grid item xs sm md lg={2}>
                                <FormHelperText shrink>Reg Number</FormHelperText>
                                <Typography variant="button">{jobDetails?.jobRegNumber || 'N/A'}</Typography>
                            </Grid>
                            {/* <Grid item xs sm md lg={3} style={{ textAlign: 'end' }}>
                            </Grid> */}
                            <Grid item xs sm md lg={6} style={{ textAlign: 'end' }}>
                                <div style={{ display: 'flex', gap: '30px', justifyContent: 'flex-end' }}>
                                    <div>
                                        <FormHelperText style={{ textAlign: 'end' }}>Chargeable Total</FormHelperText>
                                        <Typography variant="button">
                                            {/* £{jobDetails?.jobCustomerOrderTotal?.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} */}
                                            {formatters.CurrencyNumberWithPound(jobDetails?.jobCustomerOrderTotal)}
                                        </Typography>
                                    </div>
                                    <div>
                                        <FormHelperText style={{ textAlign: 'end' }}>Non Chargeable Total</FormHelperText>
                                        <Typography variant="button">
                                            {/* £{jobDetails.nonChargable?.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} */}
                                            {formatters.CurrencyNumberWithPound(jobDetails.nonChargable)}
                                        </Typography>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>

                        <Grid item container xs={12} spacing={0} justifyContent="space-between">
                            {state.openLines ? (
                                <Grid item xs={12}>
                                    <Alert severity="error">{state.openLines}</Alert>
                                </Grid>
                            ) : state.mismatchedLines ? (
                                <Grid item xs={12}>
                                    <Alert severity="Warning">
                                        {state.mismatchedLines}
                                        <button
                                            style={{
                                                background: 'none',
                                                border: 'none',
                                                color: 'blue',
                                                textDecoration: 'underline',
                                                cursor: 'pointer',
                                                fontWeight: 600,
                                                fontSize: 15
                                            }}
                                            onClick={() => setState((st) => ({ ...st, mismatchedLines: false }))}
                                        >
                                            continue
                                        </button>
                                    </Alert>
                                </Grid>
                            ) : state.isShowPerformaInvoice ? (
                                <Grid item xs={12}>
                                    <Grid container spacing={1} alignItems="center">
                                        <Grid item xs sm md lg={2}>
                                            <FormControlLabel
                                                control={<GreenCheckbox onChange={handleCheck} name="jobasproforma" checked={state.jobasproforma} />}
                                                label={state.jobasproforma && state.isProforma ? 'Proforma Created' : 'Create Proforma'}
                                                // disabled={!isDisabled || jobStatus === 'AS'}
                                            />
                                        </Grid>
                                        {state.isShowInvoice && !state.isMismatch && (
                                            <Grid item xs sm md lg={2}>
                                                <FormControlLabel
                                                    control={
                                                        <GreenCheckbox
                                                            onChange={handleCheck}
                                                            name="jobasInvoiced"
                                                            checked={state.salesInvoiceStatus == 'I'}
                                                            disabled={!isDisabled}
                                                        />
                                                    }
                                                    label="Invoice Job"
                                                />
                                            </Grid>
                                        )}
                                        <Grid item xs sm md lg={2}>
                                            {
                                                <SimpleField
                                                    inputLabel="Order number"
                                                    name="jobCustomerOrderNo"
                                                    placeholder="Order number"
                                                    onChange={inputChange}
                                                    value={state.jobCustomerOrderNo}
                                                    isRequired={state.salesInvoiceStatus == 'I'}
                                                />
                                            }
                                            <FormHelperText>{errors?.jobCustomerOrderNo}</FormHelperText>
                                        </Grid>
                                        <Grid item xs sm md lg={6}>
                                            <InputLabel shrink>Customer</InputLabel>
                                            <SelectBox
                                                List={customersList || []}
                                                name="jobCustomerID"
                                                value={state.jobCustomerID}
                                                style={{ marginTop: 0 }}
                                                onChange={inputChange}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ) : (
                                <Grid item xs={12}>
                                    <Alert severity="error">
                                        There are no chargeable lines. Click the submit button below will complete the job. Close the window if you don't want
                                        to close the job
                                    </Alert>
                                </Grid>
                            )}
                        </Grid>

                        {/* //Top Inputs  Readonly  */}
                    </>
                )}
                <Grid item xs={12}>
                    <SellerInvoiceModal
                        scheduleJobID={jobDetails?.jobID}
                        hideDetailBar={true}
                        hideInputs={true}
                        salesInvoiceStatus={state.salesInvoiceStatus}
                        jobApprovedOrderNo={state.jobApprovedOrderNo}
                        jobStatus={jobStatus}
                        handleSubmitValue={handleSubmitValue}
                        disabled={isDisabled}
                        showPerformaInvoice={showPerformaInvoice}
                        isShowPerformaInvoice={state.isShowPerformaInvoice}
                        isSubmitButtonDisabled={jobStatus === 'AS' && !state.jobasInvoiced}
                        customerID={state.jobCustomerID}
                        isProforma={state.jobasInvoiced}
                        isProformaCreated={isProformaCreated}
                        showOpenLine={showOpenLine}
                        stopLoader={stopLoader}
                        loader={state.showLoader}
                        mismatchedLines={state.mismatchedLines}
                        jobCustomerOrderNo={state.jobCustomerOrderNo}
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default JobAdminstration;
